import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import {debug} from '../../../rxjs-operators';
import {catchError, delayWhen, filter, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {Product} from '../models/product';
import {L10nTranslationService} from 'angular-l10n';
import {error} from '..';
import {ReturnPlayerUpdateStatusAction} from '../actions/anomaly-player-return';
import {conceptsActionTypes, LoadConceptsAction, LoadConceptsFailAction, LoadConceptsSuccessAction} from '../actions/concept';
import {Concept} from '../models/concept';
import {ConceptService} from '../services/concepts.service';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as _ from 'lodash';
import * as fromSite from '../../site/reducers';
import {RemoveOrderPlayerAction} from '../../order/actions/order-remove-player';

@Injectable()
export class ConceptsEffect extends BaseEffect {
  private currentClient$ = this.store.pipe(select(fromRoot.selectors.getCurrentClient), filter(client => !_.isEmpty(client)));

  // @ts-ignore
  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(conceptsActionTypes.LOAD),
    debug('remove player order exchange action received.'),
    map((action: LoadConceptsAction) => action.payload),
    switchMap((data) => this.conceptsService.getList(data).pipe(
      map((payload: SendBackResult<ArrayResponse<Concept>>) => new LoadConceptsSuccessAction(payload.data.array)),
      catchError(res => this.catchResponseError(res)),
    )),
  ) });

 /* loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(conceptsActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving Concepts list.'),
    map((action: LoadConceptsFailAction) =>
      error(this.translation.translate('Concepts_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  ) });*/

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private conceptsService: ConceptService,
              private store: Store<fromSite.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadConceptsFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadConceptsFailAction(response['error'].message);
  }
}
